import { Component, OnChanges, OnInit, ElementRef, ViewEncapsulation } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { UtilityService, AdobeAnalyticsService, AuthenticationService } from 'lib/ng2-sapmp/src/providers';
import { GridOptionsModel, ColumnDefinitionsModel, PaginationsModel, FilterService } from 'lib/ng2-sapmp/src/ui-components/custom-grid';
import { CancelParticipationService } from './../shared/providers/cancel-participation.service';
import { FanModel, RemoveList } from './../shared/models/cancel-participation.model';
import { Router, ActivatedRoute } from '@angular/router';
import { AccordionComponent } from 'lib/ng2-sapmp/src/ui-components/accordion/accordion.component';
import { PageLoaderService } from 'lib/ng2-sapmp/src/ui-components/page-loader';
import { CANCELFANDATA } from 'config';
import { BreadCrumbModel, BreadCrumbService } from 'lib/ng2-sapmp/src/ui-components/breadcrumb';
import { BaseProfileModel } from 'lib/ng2-sapmp/src/models';

@Component({
  selector: 'app-review-cancel',
  templateUrl: './review-cancel.component.html',
  styleUrls: ['./review-cancel.component.scss'],
  providers: [FilterService, CancelParticipationService, AdobeAnalyticsService],
  encapsulation: ViewEncapsulation.None
})

export class ReviewCancelComponent implements OnInit {
  formName: string;
  FANList: Array<FanModel>;
  EditedFANList: Array<FanModel>;
  UnclaimdevicesFANList: Array<FanModel>;
  gridOptions: GridOptionsModel;
  columnSelection: string;
  accordionList: any;
  accordionTitle: any;
  error: boolean;
  pageContent: any;
  text: string;
  unclaim: boolean;
  prodcode: string;
  prodDetails: any;
  fanArray: RemoveList;
  selectedbox: boolean = false;
  ibmflag: boolean;
  fanInfoList: any;
  mdmDetails: any;
  accid: any;
  user: BaseProfileModel;

  constructor(private cancelParticipationService: CancelParticipationService, private authenticationService: AuthenticationService,
     private pageloaderService: PageLoaderService, private router: Router,
    private breadCrumbService: BreadCrumbService, private utilityService: UtilityService,
    private adobeAnalyticsService: AdobeAnalyticsService, private route: ActivatedRoute) {
    this.accordionList = [];
    this.FANList = [];
    this.pageloaderService.setPageLoaderStatus(false);
  }

  ngOnInit() {
    document.title = this.utilityService.getPageTitleConfig()[this.router.routerState.snapshot.url];
    this.formName = 'Cancel Participation - Review';
    this.pageloaderService.setPageLoaderStatus(false);
    this.unclaim = sessionStorage.getItem('unclaimFlag') ? JSON.parse(sessionStorage.getItem('unclaimFlag')) : false;
    this.prodcode = sessionStorage.getItem('prodcode');
    this.ibmflag = sessionStorage.getItem('ibmflag') ? JSON.parse(sessionStorage.getItem('ibmflag')) : false;
    this.text = 'Expand the list to review the accounts you selected.';
    this.cancelParticipationService.createPageLoadProperties('REVIEW', 'review');
    if(this.ibmflag) {
      this.getFanDatamdm();
      // Content Rendering
      this.cancelParticipationService.pageContent(this.utilityService.getEnvConfig().contentUrl.cancelParticipation.review).
      subscribe(respobj => {
        this.pageContent = respobj;
        console.log(this.pageContent);
        this.pageloaderService.setPageLoaderStatus(true);
      });

    } else {
      if(this.unclaim) {
        this.getUnclaimFanData();
      }
      else {
        this.getFanData();
      }
      
      // Content Rendering
      this.pageContent = this.route.snapshot.data.pageData.cancelParticipationreview;
    }
    this.pageloaderService.setPageLoaderStatus(true);
    sessionStorage.setItem('currentUrl', '/cancelParticipation/review');
    //sessionStorage.setItem('cancelCallingBackUrl', '/cancelParticipation/review');
  }

  getFanDatamdm() {
    const FanData = this.cancelParticipationService.getCancelledFanData();
    this.FANList = FanData.cancelledFanList;
    console.log(
      'Review page'
    );
    console.log(this.FANList);
    this.columnSelection = FanData.selectedColumn;
    this.initGrid();
  }


  getFanData() {
    const FanData = this.cancelParticipationService.getCancelledFanData();
    if (FanData.cancelledFanList.length == 0) {
      this.FANList = FanData.allFanList;
    } else {
      this.FANList = FanData.cancelledFanList;
    }
    console.log(
      'Review page'
    );
    //console.log(this.FANList);
    let removefanlist = [];
    removefanlist = this.FANList;
    for(var i=0;i<removefanlist.length;i++) {
      removefanlist[i].fanId = removefanlist[i].fanId + " - Do not remove devices";
    }
    this.EditedFANList = removefanlist;
    this.columnSelection = FanData.selectedColumn;
    this.initGrid();
  }

  getUnclaimFanData() {
    const FanData = this.cancelParticipationService.getCancelledFanData();
    let totalselectedfanlist = FanData.allFanList;
    let unclaimfanlist = FanData.cancelledFanList;
    let removefanlist = [];
    function removefan(otherArray){
      return function(current){
        return otherArray.filter(function(other){
          return other.fanId == current.fanId
        }).length == 0;
      }
    }
    
    var total = totalselectedfanlist.filter(removefan(unclaimfanlist));
    var unclaim = unclaimfanlist.filter(removefan(totalselectedfanlist));
    
    removefanlist = total.concat(unclaim);
    //console.log(removefanlist);
    this.UnclaimdevicesFANList = unclaimfanlist;
    //console.log('unclaim', this.UnclaimdevicesFANList);
    this.EditedFANList = removefanlist;
    //console.log('edited', this.EditedFANList);
    for( var i=0;i<removefanlist.length;i++) {
      removefanlist[i].fanId = removefanlist[i].fanId + " - Do not remove devices";
    }
    for( var i=0;i<unclaimfanlist.length;i++) {
      unclaimfanlist[i].fanId = unclaimfanlist[i].fanId + " - Remove devices";
    }
    let fullfanlist = removefanlist.concat(unclaimfanlist);
    
    //console.log(fullfanlist);
    this.FANList = fullfanlist;
    //console.log('full', this.FANList);
    
    this.columnSelection = FanData.selectedColumn;
    this.initGrid();
  }

  initGrid() {
    const options = new GridOptionsModel();
    options.enableFiltering = false;
    options.enableSorting = false;
    options.multiSelect = false;

    const pagination = {
      recordsPerPage: 20,
      currentPage: 1,
      isServerSide: false,
      totalRecords: this.FANList.length
    };

    options.Paginations = pagination;
    options.gridData = this.FANList;
    options.columnDefinitions = CANCELFANDATA.fanList[this.columnSelection].columnDefinitions;
    this.accordionTitle = this.FANList.length + ' foundation accounts selected';
    this.gridOptions = options;
    this.accordionList = [{
      id: 1, isActive: false, category: this.accordionTitle, content: '',
      ariaLabel: {
        'expand': 'Show selected accounts.',
        'collapse': 'Hide selected accounts'
      }
    }];
  }

  onClick() {
    this.accordionList.isActive = !this.accordionList.isActive;
    if (!this.accordionList.isActive) {
     this.text = 'Expand the list to review the accounts you selected.';
    } else {
      this.text = '';
    }
  }

  onRowClick(action) {
    this.FANList = action.griddata.filter(item => item.selected === true);
  }

  createjson(aliases, fanId, status) {
    aliases.set(fanId, status);
  }

  continueToNext() {
    this.pageloaderService.setPageLoaderStatus(false);
    sessionStorage.removeItem('fanLength');
    this.prodDetails = JSON.parse(sessionStorage.getItem('manage-product'));
    //const accid = this.prodDetails.emmAccountId;
    const code = this.prodDetails.emmProductCode;
    this.mdmDetails = JSON.parse(sessionStorage.getItem('mdmDetails'));
    if(code === 'DMPGZTP'){
      this.accid = this.mdmDetails.googleEmmAccountId;
    }else if(code === 'DMPSKME'){
      this.accid = this.mdmDetails.samsungEmmAccountId;
    }
    
    
    if (this.utilityService.getEnvConfig().useMock) {
        //mock and remove
        //local testing for backend call
        
        // this.fanArray = new RemoveList();

        // this.fanArray.emmAccountId = accid;
        // this.fanArray.emmProductCode = code;
        // let fanList = new Map<String,String>();
        // let object = JSON;
        // if (this.unclaim) {
        //   this.UnclaimdevicesFANList.forEach((item) => {
        //     let str = JSON.stringify(item.fanId);
        //     let id = str.split("-");
        //     str = id[0].replace("\"", "").trim();
        //   this.createjson(fanList, str+"", 'RemoveDevice');
        //   }); 
        //   //console.log(this.UnclaimdevicesFANList);
        //   this.EditedFANList.forEach((item) => {
        //     let str = JSON.stringify(item.fanId);
        //     let id = str.split("-");
        //     str = id[0].replace("\"", "").trim();
        //   this.createjson(fanList, str+"", 'NotRemoveDevice');
        //   });
        //   //console.log(this.EditedFANList);
        // } else {
        //   this.EditedFANList.forEach((item) => {
        //     let str = JSON.stringify(item.fanId);
        //     let id = str.split("-");
        //     str = id[0].replace("\"", "").trim();
        //   this.createjson(fanList, str+"", 'NotRemoveDevice');
        //   });
        // }
        
        
        // fanList.forEach((value, key) => {
        //   var keys = key.split('.'),
        //   last = keys.pop();
        //   keys.reduce((r,a) => r[a] = r[a] || {}, object)[last] = value;
        // });

        // //console.log(JSON.stringify(object));
        // this.fanArray.fanList = object;
        // //console.log('fanArray', JSON.stringify(this.fanArray));

        // this.cancelParticipationService.saveReviewedFan(this.FANList);
        // this.cancelParticipationService.saveRemoveDevices(this.fanArray)
        // .subscribe(response => {
        //   this.pageloaderService.setPageLoaderStatus(true);
        //   // Adobe Analytics Success Type Starts
        //   this.adobeAnalyticsService.createAdobeEventProperties('CANCELPARTICIPATION', 'SUCCESS',
        //   'formResponse', 'BC_Device_Cancel_Review_FAN_Submit', 'success', 'Success_Admit',
        //   'Remove Accounts', 'Body', '/businessconsole/cancelParticipation/confirm');
        //   // Ends
        //   this.router.navigate(['cancelParticipation/confirm']);
        // }, error => {
        //   this.pageloaderService.setPageLoaderStatus(true);
        //   // Adobe Analytics Failure Type Starts
        //   this.adobeAnalyticsService.createAdobeEventProperties('CANCELPARTICIPATION', 'FAILURE',
        //   'formResponse', 'BC_Device_Cancel_Review_FAN_Submit', 'API error', 'Failure_user',
        //   'Remove Accounts', 'Body', '/businessconsole/cancelParticipation/review');
        //   // Ends
        //   this.error = true;
        // });
        //normal local with mock
        this.cancelParticipationService.saveReviewedFan(this.FANList);
        this.cancelParticipationService.saveRemoveDevices(this.fanArray);
        this.router.navigate(['cancelParticipation/confirm']);
      
    } else {
      //not mock and remove
        this.fanArray = new RemoveList();
        this.fanArray.emmProductCode = code;
        this.fanInfoList = JSON.parse(sessionStorage.getItem('fanInfoList'));
        if(code === 'DMPSKME' || code === 'DMPGZTP'){
        this.fanArray.emmAccountId = this.accid;
        }else if( code === 'DMPAABM'){
        let FANList = this.fanInfoList.filter(item => item.emmProductCode === 'DMPAABM'); 
          if (FANList.length > 0) {
          this.fanArray.emmAccountId = FANList[0].emmAccountId;
            }
      }
        let fanList = new Map<String,String>();
        let object = JSON;
        if (this.unclaim) {
          this.UnclaimdevicesFANList.forEach((item) => {
            let str = JSON.stringify(item.fanId);
            let id = str.split("-");
            str = id[0].replace("\"", "").trim();
          this.createjson(fanList, str+"", 'RemoveDevice');
          }); 
          //console.log(this.UnclaimdevicesFANList);
          this.EditedFANList.forEach((item) => {
            let str = JSON.stringify(item.fanId);
            let id = str.split("-");
            str = id[0].replace("\"", "").trim();
          this.createjson(fanList, str+"", 'NotRemoveDevice');
          });
          //console.log(this.EditedFANList);
        } else {
          this.EditedFANList.forEach((item) => {
            let str = JSON.stringify(item.fanId);
            let id = str.split("-");
            str = id[0].replace("\"", "").trim();
          this.createjson(fanList, str+"", 'NotRemoveDevice');
          });
        }
        
        fanList.forEach((value, key) => {
          var keys = key.split('.'),
          last = keys.pop();
          keys.reduce((r,a) => r[a] = r[a] || {}, object)[last] = value;
        });

        let objectKeys = Object.keys(object);
        let selectedFanList = JSON.parse(sessionStorage.getItem("selectedFanList"));
        let selectedFanArray = [];
        for(let i=0 ; i<selectedFanList.length ; i++) {
          selectedFanArray.push(selectedFanList[i].fanId);
        }
        for(let j=0 ; j<objectKeys.length ; j++) {
        if(selectedFanArray.includes(objectKeys[j])) {
          console.log("includes");
        }
        else {
          delete object[objectKeys[j]];
        }
        }

// for(let i=0 ; i<this.FANList.length ; i++) {
//   let validateFan = this.FANList[i].fanId.toString().substring(0,8);
//   for(let j=0 ; j<objectKeys.length ; j++) {
//     if(validateFan == objectKeys[j]) {
//       filterObjectArray.push(validateFan);
//     }
//   }
// }

// for(let i=0 ; i<filterObjectArray.length ; i++) {
//   for(let j=0 ; j<objectKeys.length ; j++) {
//     if(filterObjectArray[i] != objectKeys[j]) {
//       delete object[objectKeys[j]];
//     }
//   }
// }

        
        //console.log(JSON.stringify(object));
        this.fanArray.fanList = object;
        //console.log('fanArray', JSON.stringify(this.fanArray));

        this.cancelParticipationService.saveReviewedFan(this.FANList);
        this.cancelParticipationService.saveRemoveDevices(this.fanArray)
        .subscribe(response => {
          this.pageloaderService.setPageLoaderStatus(true);
          // Adobe Analytics Success Type Starts
          this.adobeAnalyticsService.createAdobeEventProperties('CANCELPARTICIPATION', 'SUCCESS',
          'formResponse', 'BC_Device_Cancel_Review_FAN_Submit', 'success', 'Success_Admit',
          'Remove Accounts', 'Body', '/businessconsole/cancelParticipation/confirm');
          // Ends

          //updating user object with signupstatus
          this.user = JSON.parse(sessionStorage.getItem('user')).user;

            if (this.user.addpAuthority !== 'NONE') {
              this.authenticationService.getFanSignedUpStatus()
              .subscribe(resp => {
                if (this.user) {
                  for (var key of Object.keys(this.user)) {
                    if (key === "fanSignedUpStatus") {
                      delete this.user[key];
                    }
                  }
                  //console.log(retrieveArray);
                  this.user.fanSignedUpStatus = this.getFanSignedUpStatus(resp.fansSummary);
                }
                this.authenticationService.setUser(this.user);
                this.authenticationService.updateEnrollStatus({showEnroll: true});
                sessionStorage.setItem("accountSummaryData", JSON.stringify(resp));
              }, () => {
                this.user.fanSignedUpStatus = 'Error';
                this.authenticationService.setUser(this.user);
              });
            } else {
              this.authenticationService.setUser(this.user);
            }

            //setting user ends


          this.router.navigate(['cancelParticipation/confirm']);
        }, error => {
          this.pageloaderService.setPageLoaderStatus(true);
          // Adobe Analytics Failure Type Starts
          this.adobeAnalyticsService.createAdobeEventProperties('CANCELPARTICIPATION', 'FAILURE',
          'formResponse', 'BC_Device_Cancel_Review_FAN_Submit', 'API error', 'Failure_user',
          'Remove Accounts', 'Body', '/businessconsole/cancelParticipation/review');
          // Ends
          this.error = true;
        });
    }
  }

  private getFanSignedUpStatus(fansSummary) {
    let fanSignedUpStatus = 'NONE';
    if (fansSummary) {
      const signedUpFansCount = fansSummary.
        filter((f) => { return f.status === 'ACTIVE' || f.status === 'READY_TO_SETUP'; }).length;
      const notSignedUpFansCount = fansSummary.
        filter((f) => { return f.status === 'PROCESSING' || f.status === 'AWAITING_SIGNUP'; }).length;
      if (signedUpFansCount > 0 && notSignedUpFansCount > 0) {
        fanSignedUpStatus = 'SOME';
      } else if (signedUpFansCount > 0 && notSignedUpFansCount === 0) {
        fanSignedUpStatus = 'ALL';
      } else {
        fanSignedUpStatus = 'NONE';
      }
    }
    return fanSignedUpStatus;
  }

  continueToNextmdm() {
    sessionStorage.removeItem('fanLength');
    this.adobeAnalyticsService.createAdobeEventProperties('CANCELPARTICIPATION', 'SUCCESS',
    'formSubmit', 'BC_Device_Cancel_Review_FAN_Submit', 'success', 'Success_Admit',
    'Remove Accounts', 'Body', '/businessconsole/cancelParticipation/confirm');
    if (this.utilityService.getEnvConfig().useMock) {
      this.pageloaderService.setPageLoaderStatus(false);
      this.cancelParticipationService.saveReviewedFan(this.FANList);
      // Adobe Analytics Success Type Starts
      this.adobeAnalyticsService.createAdobeEventProperties('CANCELPARTICIPATION', 'SUCCESS', 'formResponse',
      'BC_Device_Cancel_Review_FAN_Submit', 'success', 'Success_Admit', 'Remove Accounts', 'Body',
      '/businessconsole/cancelParticipation/confirm');
      // Ends
      this.pageloaderService.setPageLoaderStatus(true);
      this.router.navigate(['cancelParticipation/confirm']);
    } else {
      this.pageloaderService.setPageLoaderStatus(false);
      this.cancelParticipationService.saveReviewedFan(this.FANList).subscribe(response => {
        this.pageloaderService.setPageLoaderStatus(true);
        // Adobe Analytics Success Type Starts
        this.adobeAnalyticsService.createAdobeEventProperties('CANCELPARTICIPATION', 'SUCCESS',
        'formResponse', 'BC_Device_Cancel_Review_FAN_Submit', 'success', 'Success_Admit',
        'Remove Accounts', 'Body', '/businessconsole/cancelParticipation/confirm');
        // const data = { code: 'cancel_review_fan', errorType: 'SUCCESS_TYPE', successFlag: 1, msg: '' };
        // this.adobeAnalyticsService.trackEventProperties(data);
        // Ends
        this.router.navigate(['cancelParticipation/confirm']);
      }, error => {
        this.pageloaderService.setPageLoaderStatus(true);
        // Adobe Analytics Failure Type Starts
        this.adobeAnalyticsService.createAdobeEventProperties('CANCELPARTICIPATION', 'FAILURE',
        'formResponse', 'BC_Device_Cancel_Review_FAN_Submit', 'API error', 'Failure_user',
        'Remove Accounts', 'Body', '/businessconsole/cancelParticipation/review');
        // const data = { code: 'cancel_review_fan', errorType: 'FAILURE_TYPE', successFlag: 0, msg: error.statusText };
        // this.adobeAnalyticsService.trackEventProperties(data);
        // Ends
        this.error = true;
      });
    }
  }

  changeEvent($event) {
    if ($event.target.checked) {
        this.selectedbox= true;
    }
    else {
        this.selectedbox= false;
    }
  }

  backToPreviousPage(event) {
    event.preventDefault();
    sessionStorage.removeItem('CancelParticipationData');
    if (this.unclaim) {
      const previousUrl = sessionStorage.getItem('previousRoute');
      if(previousUrl === '/cancelParticipation/review') {
        this.router.navigate(['cancelParticipation/review']);
        }
        else {
        this.router.navigate(['cancelParticipation/unclaimdevices']);
        }
    } else {
      this.router.navigate(['cancelParticipation/selectfan']); 
    }
  }

  backToPreviousPagemdm(event) {
    event.preventDefault();
    this.router.navigate(['cancelParticipation/selectfan']);
  }
}
